/**
 * @file: 货架渲染
 * @author: xiaolong.huang@dmall.com
 */

import { Watcher } from '../../observe/index';
import * as UIToolkit from '../../UIToolkit/index';
import * as ShelfRenderCore from './renderCore/index';

// 货架渲染
function shelfRender(cube: CubeNode): void {
    UIToolkit.targetShelfsLayerHeight(cube.id);

    // 去掉resize的偏移
    ShelfRenderCore.clearResizePosition(cube);

    // 渲染货架底部渲染Watcher
    new Watcher(() => {
        ShelfRenderCore.setShelfFooterStyle(cube);
    });

    // 渲染层板放置区域宽高
    new Watcher(() => {
        ShelfRenderCore.setShelfDropAreaStyle(cube);
    });

    //渲染货架title和货架id
    new Watcher(() => {
        ShelfRenderCore.setShelfTitleStyle(cube);
    });

    // 货架索引标记class
    ShelfRenderCore.addShelfIndexClass(cube);

    // 错误信息
    new Watcher(() => {
        ShelfRenderCore.renderErrorMsg(cube);
    });

    // 层板纵向布局网格
    new Watcher(() => {
        ShelfRenderCore.renderGrid(cube);
    });

    // 设置流动边框动画属性
    UIToolkit.setFlowBorderPropertiy(cube, '.shelves-box');
}

export default shelfRender;
